module.exports = __webpack_public_path__ + "img/23.237befd7.jpg";